module.exports = __webpack_public_path__ + "img/cr.a6c3cedb.svg";